import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import RelatedAudio from './RelatedAudio';

import { recent } from '../../redux/audio/selectors';
import { getRecent } from '../../redux/audio/actions';

const selector = createStructuredSelector({
  recent,
});

export default connect(selector, { getRecent })(RelatedAudio);
